import { useRef } from "react";
import { gsap, useGSAP, MOTION_OK } from "../gsap";
import { inlineImage, manifesto } from "../content";

const words = manifesto.split(" ");
const PILL_AFTER = 8; // inline image sits after the first sentence

export function Manifesto() {
  const root = useRef<HTMLElement>(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        // Reading pace is tied to scroll so the statement is read, not skimmed.
        gsap.from(".word", {
          opacity: 0.12,
          stagger: 0.1,
          ease: "none",
          scrollTrigger: { trigger: root.current, start: "top 70%", end: "bottom 60%", scrub: true },
        });
      });
    },
    { scope: root },
  );

  return (
    <section ref={root} className="px-4 py-20 md:px-8 md:py-48">
      <p className="mx-auto max-w-6xl font-display text-[clamp(1.75rem,4.4vw,4.5rem)] font-bold leading-[1.08] tracking-[-0.03em]">
        {words.map((w, i) => (
          <span key={i}>
            <span className="word">{w}</span>{" "}
          </span>
        ))}
      </p>
    </section>
  );
}
